import { AppApi, ScreenView, el, panel, button, jellyAmount, fmt } from '../ui/app-api'

function readHiScore(): number {
  try {
    return Number(localStorage.getItem('bluebob_hiscore') || 0)
  } catch {
    return 0
  }
}

export function createTitleScreen(api: AppApi): ScreenView {
  const root = el('div', { class: 'screen' })
  const logo = el('h1', { class: 'logo' })
  logo.append(document.createTextNode('BlueBob'), el('span', { class: 'sub', text: 'Jellyfish Fields' }))
  const tagline = el('p', { class: 'tagline', text: 'Squeeze jellyfish • collect the reef • rule Bikini Bottom' })
  const play = button('PLAY', { onClick: () => api.playStory() })
  const menu = button('MAIN MENU', { variant: 'secondary', onClick: () => api.go('menu') })
  const hi = el('p', { class: 'muted center' })
  root.append(logo, tagline, play, menu, hi)
  return {
    el: root,
    onShow() {
      api.audio.unlock()
      const best = readHiScore()
      hi.textContent = best > 0 ? `Best dive: ${fmt(best)}` : 'Tap PLAY to take your first dive'
    },
  }
}

export function createMainMenu(api: AppApi): ScreenView {
  const root = el('div', { class: 'screen' })
  const p = panel()
  const logo = el('h1', { class: 'logo', style: { fontSize: 'clamp(1.8rem,6vw,3rem)' } })
  logo.append(document.createTextNode('BlueBob'))
  const list = el(
    'div',
    { class: 'menu-list' },
    button('PLAY', { onClick: () => api.playStory() }),
    button('SHOP', { variant: 'secondary', onClick: () => api.go('shop') }),
    button('LEADERBOARD', { variant: 'secondary', onClick: () => api.go('leaderboard') }),
    button('SETTINGS', { variant: 'ghost', onClick: () => api.go('settings') }),
  )
  const bal = el('div', { class: 'center' })
  const status = el('p', { class: 'muted center' })
  p.append(logo, list, bal, status)
  root.append(p)
  return {
    el: root,
    onShow() {
      api.audio.unlock()
      bal.replaceChildren(el('span', { class: 'muted', text: 'Jelly: ' }), jellyAmount(api.economy.state.jelly))
      status.textContent = api.economy.state.online ? '' : 'Offline — progress saved locally'
    },
  }
}
